module.exports = __webpack_public_path__ + "img/tick-inside-circle.5e18caa0.svg";